import {COPILOT_APP_SLUG} from '@github-ui/copilot-shared-ui/agents/agent-helpers'
import {AGENT_INFO_REGISTRY} from '@github-ui/copilot-shared-ui/agents/agent-info-registry'
import type {AgentProfile} from '../agent-profile'
import {CLI_PROFILE} from './cli-profile'

// Reuse CLI presentation until App-specific UX is designed, without changing identity.
export const COPILOT_APP_PROFILE: Partial<AgentProfile> = {
  ...CLI_PROFILE,
  slug: COPILOT_APP_SLUG,
  agentInfo: AGENT_INFO_REGISTRY[COPILOT_APP_SLUG],
}
